<template>
  <div>
    <div id="graficoTipos"></div>
  </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'Charts-Convenios',
    computed: {
      ...mapGetters('schedule', ['getList', 'getAvailableAppointments', 'getAppointments'])
    },
    props: ['categories', 'value'],
    watch: {
      getList () {
        this.dataSource()
      }
    },
    methods: {
      dataSource () {
        const tipos = !this.getList ? [] : this.getList.map(item => item.type)
        const dataTipos = tipos.filter(function (element) {
          return element !== undefined
        })
        const baseTipos = _(dataTipos)
          .countBy()
          .map((value, key) => ({ key, value }))
          .orderBy(['value'], ['desc'])
          .value()

        const categoriesTipos = baseTipos.map(item => item.key)
        const valuesTipos = baseTipos.map(item => item.value)
        this.setup({categoriesTipos, valuesTipos})
      },
      setup (obj) {
        const { categoriesTipos, valuesTipos } = obj
        Highcharts.chart('graficoTipos', {
          chart: {
            type: 'column'
          },
          title: {
            text: 'Tipos'
          },
          subtitle: {
            text: 'Fonte: Risc Sistemas em Saúde'
          },
          xAxis: {
            categories: categoriesTipos,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: ''
            }
          },
          series: [{
            name: 'Quantidade',
            data: valuesTipos
          }]
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/schedule/Type.vue